import color from "../../constants/color";

const style = {
  container: {
    px: "15px",
    py: 2,
    backgroundColor: "#F1F1F1",
    minHeight: "100vh",
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    mb: 3,
    flexWrap: "wrap",
    gap: 2,
  },
  title: {
    fontWeight: 600,
    fontSize: "24px",
    color: color.text,
    mb: 0.5,
  },
  subtitle: {
    fontSize: "14px",
    color: color.lightText,
  },
  backButton: {
    borderRadius: "50px",
    textTransform: "none",
    px: 3,
    py: 1,
    fontWeight: 500,
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.05)",
    p: 3,
    mb: 3,
  },
  sectionTitle: {
    fontSize: "18px",
    fontWeight: 600,
    color: color.text,
    mb: 0.5,
  },
  sectionSubtitle: {
    fontSize: "13px",
    color: color.lightText,
    mb: 2,
  },
  allowanceRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: 2,
    py: 1.5,
    borderBottom: `1px solid ${color.lightGray}`,
  },
  allowanceName: {
    fontSize: "14px",
    fontWeight: 500,
    color: color.text,
  },
  allowanceBreakdown: {
    fontSize: "12px",
    color: color.lightText,
    mt: 0.25,
  },
  allowanceValue: {
    fontSize: "15px",
    fontWeight: 600,
    color: color.text,
    whiteSpace: "nowrap",
  },
  packCard: {
    border: `1px solid ${color.lightGray}`,
    borderRadius: "10px",
    p: 2,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
  },
  packName: {
    fontSize: "15px",
    fontWeight: 600,
    color: color.text,
  },
  packDetail: {
    fontSize: "13px",
    color: color.lightText,
  },
  packPrice: {
    fontSize: "20px",
    fontWeight: 600,
    color: color.text,
    mt: 1,
  },
  packButton: {
    mt: 1.5,
    textTransform: "none",
    borderRadius: "50px",
  },
  tableHeaderCell: {
    fontSize: { xs: "14px", md: "15px" },
    fontWeight: 500,
    color: color.text,
    borderBottom: `1px solid ${color.lightGray}`,
  },
  tableCell: {
    fontSize: "14px",
    color: color.text,
    borderBottom: `1px solid ${color.lightGray}`,
  },
  emptyText: {
    fontSize: "14px",
    color: color.lightText,
    py: 2,
  },
  statusChip: {
    fontSize: "12px",
    fontWeight: 500,
    height: "24px",
  },
  loadingBox: {
    display: "flex",
    justifyContent: "center",
    py: 3,
  },
  errorAlert: {
    mb: 2,
  },
};

export default style;
